import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { Col, Form, message, Row } from "antd";
import { InputField, DatePickerField, SelectInput, TextareaField } from "../../blueplanitUtils/InputField";
import Modal from "../../blueplanitUtils/Modal";
import { fetchAdminLeaves, updateAdminRequestAsync } from "../../Slices/adminLeaveSlice";
import { useDispatch } from "react-redux";
import { getOptionsByPath } from "../../utilsdata";
import { ADMIN_LEAVES, LEAVE_STATUS } from "../../Dropdownmanager";
import { Button } from "antd";
import { CheckOutlined } from "@ant-design/icons";



export const AdminLeaveAddModelPopup = ({ leaveData, isOpen, onClose, refetch }) => {
  const dispatch = useDispatch()
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails)
  const teamReports = loginUser.teamsReportDirect.map(item => item.reportingId);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

  const [formData, setFormData] = useState({
    leaveType: null,
    leaveStatus: null,
    fromDate: null,
    toDate: null,
    numberOfDays: 0,
    leaveReason: "",
    remarks: null,
    fromSession: "session1",
    toSession: "session1",
  });
  const [isModified, setIsModified] = useState(false);

  const leaves = [
    { value: "", label: "Select LeaveType" },
    { value: "Paid Leaves", label: "Paid Leave" },
    { value: "Casual Leave", label: "Casual Leave" },
    { value: "Sick Leave", label: "Sick Leave" },
    { value: "Maternity Leave", label: "Maternity Leave" },
    { value: "Paternity Leave", label: "Paternity Leave" },
  ];

  const leaveStatus = [
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Declined", label: "Declined" },
  ];

  const [isDisabled, setIsDisabled] = useState(false);
  const startTimer = () => {
    setIsDisabled(true);
    setTimeout(() => {
      setIsDisabled(false);
    }, 3000);
  };

  useEffect(() => {
    if (leaveData) {
      setFormData({
        leaveType: leaves.find((leave) => leave.value === leaveData.leaveType) || null,
        leaveStatus: leaveStatus.find((leave) => leave.value === leaveData.leaveStatus) || null,
        fromDate: leaveData.startDate ? dayjs(leaveData.startDate) : null,
        toDate: leaveData.endDate ? dayjs(leaveData.endDate) : null,
        leaveReason: leaveData.leaveReason || "",
        remarks: leaveData?.remarks || "",
        numberOfDays: leaveData.leaveDays || 0,

        fromSession:
          leaveData?.session1 === "true"
            ? "session1"
            : leaveData?.session1 === "false"
              ? "session2"
              : null,

        toSession:
          leaveData?.session2 === "true"
            ? "session2"
            : leaveData?.session2 === "false"
              ? "session1"
              : null,
      });
      setIsModified(false);
    }
  }, [leaveData]);

  const calculateDays = (fromDate, fromSession, toDate, toSession) => {
    if (!fromDate || !toDate) return 0;
    const start = dayjs(fromDate);
    const end = dayjs(toDate);

    const dayDiff = end.diff(start, 'day');

    let totalDays = Math.ceil(dayDiff);
    if (start.isSame(end, 'day')) {
      if (fromSession === "session1" && toSession === "session1") return 0.5;
      if (fromSession === "session1" && toSession === "session2") return 1;
      if (fromSession === "session2" && toSession === "session2") return 0.5;
    } else {
      if (fromSession === "session1" && toSession === "session1") totalDays += 0.5;
      else if (fromSession === "session1" && toSession === "session2") totalDays += 1;
      else if (fromSession === "session2" && toSession === "session1") totalDays += 0;
      else if (fromSession === "session2" && toSession === "session2") totalDays += 0.5;
    }

    return totalDays;
  };

  const handleChange = (name, value) => {
    setFormData((prevData) => {
      let updatedData = { ...prevData, [name]: value };

      if (["fromDate", "toDate"].includes(name) && value) {
        updatedData[name] = dayjs(value);
      }
      if (["fromDate", "toDate", "fromSession", "toSession"].includes(name)) {
        updatedData.numberOfDays = calculateDays(
          updatedData.fromDate,
          updatedData.fromSession,
          updatedData.toDate,
          updatedData.toSession
        );
      }
      if (name === "fromDate" && updatedData.toDate && updatedData.toDate.isBefore(updatedData.fromDate)) {
        updatedData.toDate = null;
        updatedData.numberOfDays = 0;
      }
      if (name === "toDate" && updatedData.fromDate && updatedData.toDate.isBefore(updatedData.fromDate)) {
        updatedData.toDate = null;
        updatedData.numberOfDays = 0;
      }
      if (leaveData) {
        setIsModified(true);
      }

      return updatedData;
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const { fromDate, toDate, numberOfDays, fromSession, toSession, leaveStatus, remarks } = formData;
    const totalDays = parseFloat(numberOfDays);
    const leaveTypeLabel = formData.leaveType?.value?.toLowerCase();

    // Only check when admin is approving
    if (leaveStatus?.value === "Approved") {

      // ✅ MATERNITY RULE
      if (leaveTypeLabel === "maternity leave" && totalDays > 30) {
        const extraDays = totalDays - 30;

        const confirm = window.confirm(
          `Blueplanit pays only 30 days for maternity leave.\nThe remaining ${extraDays} days will be considered as Loss of Pay.\n\nDo you want to proceed?`
        );

        if (!confirm) return;
      }

      // ✅ PATERNITY RULE
      if (leaveTypeLabel === "paternity leave" && totalDays > 3) {
        const extraDays = totalDays - 3;

        const confirm = window.confirm(
          `Blueplanit pays only 3 days for paternity leave.\nThe remaining ${extraDays} days will be considered as Loss of Pay.\n\nDo you want to proceed?`
        );

        if (!confirm) return;
      }
    }

    if (leaveData && !isModified) {
      startTimer();
      message.error("You haven't updated anything. Please make changes before submitting.");
      return;
    }
    const leaveId = leaveData ? leaveData._id : null;
    const newStatus =
      typeof leaveStatus === "string"
        ? leaveStatus
        : leaveStatus?.value || leaveData?.leaveStatus || "";

    try {
      if (leaveData) {
        startTimer()
        const formStartDateTimestamp = fromDate instanceof Date ? fromDate.getTime() : new Date(fromDate).getTime();
        const formEndDateTimestamp = toDate instanceof Date ? toDate.getTime() : new Date(toDate).getTime();

        const leaveStartDateTimestamp = leaveData.startDate ? leaveData.startDate : null;
        const leaveEndDateTimestamp = leaveData.endDate ? leaveData.endDate : null;
        const isDifferentLeave =
          leaveData.leaveStatus !== formData.leaveStatus.value ||
          formStartDateTimestamp !== leaveStartDateTimestamp ||
          formEndDateTimestamp !== leaveEndDateTimestamp ||
          (formData.fromSession === "session1" ? "true" : "false") !== leaveData.session1 ||
          (formData.toSession === "session2" ? "true" : "false") !== leaveData.session2;

        if (!isDifferentLeave) {
          message.error({
            content: "You haven't updated anything. Please make changes before submitting.",
            duration: 3,
            className: 'custom-toast-center',
          });
          return;
        }
        const leaveUpdateInput = {
          leaveId,
          newStatus,
          remarks: remarks,
          leaveDays: numberOfDays.toString(),
          newStartDate: dayjs(fromDate).format("YYYY-MM-DD"),
          newEndDate: dayjs(toDate).format("YYYY-MM-DD"),
          approvedBy: loginUser?.firstname + " " + loginUser?.lastname,
          session1: leaveData?.session1 ?? null,
          session2: leaveData?.session2 ?? null,
        };

        const resultAction = await dispatch(updateAdminRequestAsync([leaveUpdateInput]));

        if (updateAdminRequestAsync.fulfilled.match(resultAction)) {
          message.success("Leave updated successfully!");

          await dispatch(fetchAdminLeaves({
            empid: teamReports,
            role: loginUser.role,
            userDepartment: loginUser.department
          }));

          onClose();
        } else {
          throw new Error(resultAction.payload || "Failed to update leave");
        }
      }
    } catch (error) {
      console.error("Error updating leave status:", error);
    }
  };

  const resetForm = () => {
    setFormData({
      leaveType: null,
      fromDate: null,
      toDate: null,
      numberOfDays: 0,
      leaveReason: "",
      fromSession: "session1",
      toSession: "session1",
      remarks: "",
    });
    onClose();
  };
  const handleStatusUpdate = (status) => {
    setFormData((prev) => {
      const isSameStatus = prev.leaveStatus?.value === status;

      return {
        ...prev,
        leaveStatus: isSameStatus
          ? null //  Deselect if clicked again
          : { label: status, value: status },
      };
    });

    setIsModified(true);
  };



  return (

    <div
      className="modal-backdrop"
      style={{
        backgroundColor: "rgba(0,0,0,0.65)"
      }}
    >

      <Modal

        id="edit_leave"
        title={leaveData ? "Edit Leave" : "Add Leave"}
        isOpen={`${isOpen ? "show" : ""}`}
        style={{ display: isOpen ? "block" : "none" }}
        handleModalClose={resetForm}
        handleSubmit={handleSubmit}
        size="md"
        disabled={leaveData ? !isModified || isDisabled : isDisabled}
      >
        <Form layout="vertical" style={{ marginBottom: 0 }}>

          <Row gutter={[16, 8]}>

            <Col span={12}>
              <Form.Item style={{ marginBottom: 8 }}>


                <SelectInput
                  label="Leave Type"
                  options={leaves}
                  value={formData.leaveType}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item style={{ marginBottom: 8 }}>
                <SelectInput
                  label="Leave Status"
                  options={getOptionsByPath(NestedDatabucket, [ADMIN_LEAVES, LEAVE_STATUS])}
                  value={formData.leaveStatus}
                  onChange={(value) => handleChange("leaveStatus", value)}
                />
              </Form.Item>
            </Col>
          </Row>


          <Row gutter={[16, 8]}>

            <Col span={12}>
              <Form.Item style={{ marginBottom: 8 }}>
                <DatePickerField
                  label="From Date"
                  value={formData.fromDate}
                  format="DD/MM/YYYY"
                  disabled
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item style={{ marginBottom: 8 }}>
                <SelectInput
                  label="From Session"
                  value={formData.fromSession}
                  disabled
                  options={[
                    { label: "Session 1", value: "session1" },
                    { label: "Session 2", value: "session2" },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>


          <Row gutter={[16, 8]}>

            <Col span={12}>
              <Form.Item style={{ marginBottom: 8 }}>
                <DatePickerField
                  label="To Date"
                  value={formData.toDate}
                  format="DD/MM/YYYY"
                  disabled
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item style={{ marginBottom: 8 }}>
                <SelectInput
                  label="To Session"
                  value={formData.toSession}
                  disabled
                  options={[
                    { label: "Session 1", value: "session1" },
                    { label: "Session 2", value: "session2" },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>


          <Row gutter={[16, 8]}>
            <Col span={12}>
              <Form.Item style={{ marginBottom: 8 }}>
                <InputField
                  label="Number of Days"
                  value={formData.numberOfDays}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item style={{ marginBottom: 8 }}>
                <InputField
                  label="Remaining Leaves"
                  value={leaveData?.remainingLeaves || 12}
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>


          <Row gutter={[16, 8]} style={{ marginTop: 8 }}>
            <Col span={24} style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>

              {/* Decline Button */}
              <Button
                danger
                type={formData.leaveStatus?.value === "Declined" ? "primary" : "default"}
                icon={formData.leaveStatus?.value === "Declined" ? <CheckOutlined /> : null}
                onClick={() => handleStatusUpdate("Declined")}
                style={{
                  height: 30,
                }}
              >
                Decline
              </Button>

              {/* Approve Button */}
              <Button
                type={formData.leaveStatus?.value === "Approved" ? "primary" : "default"}
                icon={formData.leaveStatus?.value === "Approved" ? <CheckOutlined /> : null}
                onClick={() => handleStatusUpdate("Approved")}
                style={{
                  backgroundColor:
                    formData.leaveStatus?.value === "Approved" ? "green" : "",
                  borderColor:
                    formData.leaveStatus?.value === "Approved" ? "green" : "green",
                  color:
                    formData.leaveStatus?.value === "Approved" ? "white" : "green",
                  height: 30,
                }}
              >
                Approve
              </Button>

            </Col>
          </Row>



          <Row gutter={[16, 4]}>
            <Col span={24}>
              <Form.Item label="Leave Remarks" labelCol={{ span: 24 }} style={{ marginBottom: 8 }}>
                <TextareaField
                  rows={4}
                  value={formData.remarks}
                  onChange={(e) => handleChange("remarks", e.target.value)}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};
